import loadable from '../../shared/utils/loadable';

// Code splitting!

const ExternalRedirect = loadable(() => import('../containers/ExternalRedirect'));
const ForgotPassword = loadable(() => import('../containers/ForgotPassword'));
const Invitation = loadable(() => import('../containers/Invitation'));
const Login = loadable(() => import('../containers/Login'));
const Mfa = loadable(() => import('../containers/Mfa'));
const OAuthRedemption = loadable(() => import('../containers/OAuthRedemption'));
const Register = loadable(() => import('../containers/Register'));
const Logout = loadable(() => import('../containers/Logout'));
const PasswordReset = loadable(() => import('../containers/PasswordReset'));
const TermsOfService = loadable(() => import('../containers/TermsOfService'));

const routes = [{
	path: ['/forgotpassword', '/forgot-password'],
	component: ForgotPassword,
}, {
	path: '/invitations',
	component: Invitation,
}, {
	// NOTE: Deprecated route
	path: '/login-or-register',
	component: Login,
}, {
	path: '/login',
	component: Login,
}, {
	path: '/mfa',
	component: Mfa,
}, {
	path: '/register/terms-of-service',
	component: TermsOfService,
}, {
	path: '/register',
	component: Register,
}, {
	path: '/logout',
	component: Logout,
}, {
	path: ['/passwordreset', '/password-reset'],
	component: PasswordReset,
}, {
	path: '/redirect/external',
	component: ExternalRedirect,
}, {
	path: '/oauth/redemption',
	component: OAuthRedemption,
}];

export default routes;
